import { useCallback, useEffect, useState } from 'react';

import {
  CLASS_ID_PARAM,
  JOIN_CODE_NOTIFICATION_MESSAGE,
  NOTIFICATION_SHOW_DELAY,
} from 'src/constants/notifications.constants';
import { useActiveUserClasses } from 'src/hooks/use-active-user-classes';
import { notificationsService } from 'src/services/notifications.service';

export const useJoinClassNotification = () => {
  const [joinedClassId, setJoinedClassId] = useState<string>();

  const { activeUserClasses } = useActiveUserClasses();

  const getSearchParams = useCallback(() => {
    const currentLocation = new URL(window.location.href);

    return currentLocation.searchParams;
  }, []);

  const removeClassIdFromUrl = useCallback(() => {
    const searchParams = getSearchParams();
    searchParams.delete(CLASS_ID_PARAM);

    const updatedSearchParams = searchParams.toString()
      ? `?${searchParams.toString()}`
      : '';

    window.history.replaceState(
      null,
      '',
      `${window.location.origin}/home/student${updatedSearchParams}`,
    );
  }, [getSearchParams]);

  useEffect(() => {
    const searchParams = getSearchParams();
    const classIdSearchParam = searchParams.get(CLASS_ID_PARAM);

    if (!classIdSearchParam) return;

    setJoinedClassId(classIdSearchParam);
  }, [getSearchParams]);

  useEffect(() => {
    if (!activeUserClasses || !joinedClassId) return;

    const joinedClass = activeUserClasses.find(
      (cl) => cl.sourcedId === joinedClassId,
    );

    if (joinedClass) {
      setTimeout(() => {
        notificationsService.showNotification(JOIN_CODE_NOTIFICATION_MESSAGE);
      }, NOTIFICATION_SHOW_DELAY);
    }

    removeClassIdFromUrl();
  }, [activeUserClasses, joinedClassId, removeClassIdFromUrl]);
};
